import React from 'react';

const Footer = () => {
  return (
    <footer className="footer-area" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="/DD Logo w Icon.png"
              alt="Deed Digital Logo"
              className="footer-brand-img"
              width="120"
              height="40"
            />
          </div>
          <div className="footer-text">
            <div className="copyright-text">&copy; 2025 DeedDigital.co.uk<br />All Rights Reserved</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
